import { createFileRoute } from '@tanstack/react-router';

import { ContactsMobilePage } from '@/pages/contacts/contacts-mobile-page';
import { ContactsPage } from '@/pages/contacts/contacts-page';
import { useMobile } from '@/shared/lib/use-mobile';

function ContactsRoute() {
  const isMobile = useMobile();
  return isMobile ? <ContactsMobilePage /> : <ContactsPage />;
}

export const Route = createFileRoute('/my/contacts')({ component: ContactsRoute });
